import {API_GATEWAY, API_UPLOAD_URL} from '/constants/API_constants.js';
import {quitPlaque} from '/plaque/quit_plaque_window.js';
import {makePlaqueQuitToggle} from '/plaque/quit_plaque_toggle.js';
import { createLoadingScreen } from "/loading_screen_functions/loading_screen_functions.js";
import { insertPlaqueAndAlertWindow } from "/alert/alert_functions.js";
import { logOut } from '/login/logout.js';
import { createElement } from "/elements_functions/new_elements.js";
import { createRequestObject } from '/request/request.js';
import { makeNewButton } from "/buttons_functions/custom_button_functions.js";
import { createPreviewPromise } from '/create_node/preview_read.js';
import { isValidBranch } from '/create_node/node_validation.js';
import { ValidationError } from '/validation/param_validator.js';
import { createPreviewTypeCircle } from '/create_node/preview_type_functions.js';

const mainBodyElement = document.querySelector('body');

const listOfTypes = ['Link to a SoundCloud audio', 'Link to a Youtube video', 'Upload an image',
    //'Upload a PDF file',
    'An idea for a content'];

const listOfTypesFunctionsInit = {
    'Link to a SoundCloud audio' : soundCloudContentInsertInitialize,
    'Link to a Youtube video' : youTubeContentInsertInitialize,
    //'Upload a PDF file' : pdfContentUploadInitialize,
    'Upload an image' : imageContentUploadInitialize
}

const listOfTypesReadProperties = {
    'Link to a Youtube video' : 'YT_URL',
    'Link to a SoundCloud audio' : 'SCL_URL',
    'Upload an image' : 'PIC_FILE',
    //'Upload a PDF file' : {method : 'upload', prefix : 'pdf-file '},
    //'Upload a PDF file' : PDF_FILE,
    'An idea for a content' : 'IDEA'
}

export default function createNewBranchButtonPress(parentId=null) {
    const plaque = document.createElement('div');
    plaque.setAttribute('id', 'plaque');
    mainBodyElement.append(plaque);

    const node_window = document.createElement('div');
    node_window.setAttribute('id', 'create-node-window');
    plaque.append(node_window);

    //-----------------------Select type section--------------------------
    const selectTypeSection = document.createElement('div');
    const selectButton = document.createElement('select');
    
    const chooseType = document.createElement('option');
    chooseType.innerText = 'Choose the type of preview';
    selectButton.append(chooseType);
    for(let i of listOfTypes) {
        const typeOption = document.createElement('option');
        typeOption.innerText = i;
        selectButton.append(typeOption);
    }

    selectButton.addEventListener('change', e => selectTypeChange(e));

    selectTypeSection.append(selectButton);
    selectTypeSection.setAttribute('id', 'select-type-section');

    node_window.append(selectTypeSection);

    //-------------------------Name of the content-------------------------
    const nameSection = document.createElement('div');
    const nameInput = document.createElement('textarea');

    nameInput.placeholder = 'Name of your content';
    nameInput.maxLength = 100;
    nameInput.addEventListener('input', e => textAreaContentReszie(e));

    nameSection.append(nameInput);
    nameSection.setAttribute('id', 'name-section');

    node_window.append(nameSection);
    //-------------------------Resources insertion-------------------------
    const resourcesSection = document.createElement('div');
    const resourcesTitle = document.createElement('p');
    const resourceLinksGroup = document.createElement('div');
    
    createNewLink(resourceLinksGroup);

    resourcesTitle.innerText = 'Links to resources:'

    resourceLinksGroup.setAttribute('id', 'resource-links-group');

    resourcesSection.append(resourcesTitle);
    resourcesSection.append(resourceLinksGroup);
    resourcesSection.setAttribute('id', 'resource-section');

    node_window.append(resourcesSection);

    //-------------------------Description---------------------------------
    const descriptionSection = document.createElement('div');
    const descriptionBody = document.createElement('textarea');

    descriptionBody.placeholder = 'Add a description...';
    descriptionBody.maxLength = 65535;
    descriptionBody.addEventListener('input', e => textAreaContentReszie(e));

    descriptionSection.append(descriptionBody);
    descriptionSection.setAttribute('id', 'description-section');

    node_window.append(descriptionSection);
    //-------------------------Tags----------------------------------------
    const tagsSection = document.createElement('div');
    const tagsInput = document.createElement('input');

    tagsInput.setAttribute('id', 'tags-input');
    tagsInput.placeholder = 'Add a tag...'
    tagsInput.addEventListener('keypress', e => tagsInputKey(e))

    tagsSection.append(tagsInput);
    tagsSection.setAttribute('id', 'tags-section');

    node_window.append(tagsSection);
    //-------------------------Anonymous warning----------------------------
    const loginToken = localStorage.getItem("branchof_access_token");
    if(loginToken===null || loginToken===undefined) {
        const anonymousWarning = createElement('p', "create-node-anonymous-warning", null);
        anonymousWarning.innerText = "Remember: You are creating this branch anonymously. You will be given a reclaim token that you can use to reclaim authorship of this branch later, when you become a registered user. Until then, the author for this branch will be listed as anonymous.";
        node_window.append(anonymousWarning);
    }
    //-------------------------Buttons--------------------------------------
    const buttonSection = document.createElement('div');
    const cancelButton = document.createElement('button');
    const publishButton = document.createElement('button');

    cancelButton.innerText = 'Quit';
    publishButton.innerText = 'Publish the branch';
    publishButton.addEventListener('click', () => publish(plaque, parentId, buttonSection, node_window));

    buttonSection.append(cancelButton);
    buttonSection.append(publishButton);
    buttonSection.setAttribute('id', 'buttons-section');

    node_window.append(buttonSection);

    makePlaqueQuitToggle(plaque,
        'Are you sure you want to quit branching?',
        'Go back',
        'Quit'
    );

    cancelButton.addEventListener('click', ()=> quitPlaque(
        plaque,
        'Are you sure you want to quit branching?',
        'Go back',
        'Quit'
    ));

}

function plaquePress(e) {
    if(e.target.id==='plaque')
        document.getElementById('plaque').remove();
}

function textAreaContentReszie(e) {
    const textarea = e.target;
    // Create a hidden div element if it doesn’t already exist
    let hiddenDiv = textarea._hiddenDiv;

    if (!hiddenDiv) {
        hiddenDiv = document.createElement('div');
        hiddenDiv.style.position = 'absolute';
        hiddenDiv.style.visibility = 'hidden';
        hiddenDiv.style.whiteSpace = 'pre-wrap';
        hiddenDiv.style.wordWrap = 'break-word';
        hiddenDiv.style.boxSizing = 'border-box';
        hiddenDiv.style.padding = '0'; // Remove padding for accurate height calculation
        hiddenDiv.style.border = 'none'; // Exclude borders in height calculation
        textarea._hiddenDiv = hiddenDiv; // Attach it to the textarea for reuse
        hiddenDiv.style.left = 0;
        hiddenDiv.style.top = 0;
        document.getElementById('plaque').append(hiddenDiv);
    }

    // Mirror textarea styles to the hidden div
    const computedStyle = window.getComputedStyle(textarea);
    hiddenDiv.style.width = computedStyle.width;
    hiddenDiv.style.font = computedStyle.font;
    hiddenDiv.style.lineHeight = computedStyle.lineHeight;
    hiddenDiv.style.padding = 0;

    // Set the content of the hidden div to match the textarea
    hiddenDiv.textContent = textarea.value || textarea.placeholder || ' ';

    // Calculate the new height
    const singleLineHeight = parseInt(computedStyle.lineHeight, 10); // Height for one line
    const newHeight = Math.max(hiddenDiv.offsetHeight, singleLineHeight); // Ensure at least one line fits

    // Apply the calculated height to the textarea
    textarea.style.height = `${newHeight}px`;

}

//--------------Type of content functions-----------------------------------------------------------------------
function selectTypeChange(e) {
    const selectElement = e.target;

    deleteContentInsertionSection();

    const contentInsertInitialize = listOfTypesFunctionsInit[selectElement.value];    
    console.log(contentInsertInitialize, listOfTypesFunctionsInit[selectElement.value]);
    

    if(contentInsertInitialize!==null && contentInsertInitialize!==undefined) {
        contentInsertInitialize();
    }
    
}

function deleteContentInsertionSection() {
    const contentInsertSection = document.getElementById('content-preview-section');

    if(contentInsertSection!==null)
        contentInsertSection.remove();
}

function createInsertUrl(placeholder, previewFunction) {
    const contentInsertInput = document.createElement('input');
    contentInsertInput.setAttribute('id', 'content-insert-url');

    contentInsertInput.placeholder = placeholder;
    contentInsertInput.addEventListener('change', e => previewFunction(e));

    return contentInsertInput;

}

function createUploadFileLabelAndInput(labelText, previewFunction) {
    const contentUploadLabel = document.createElement('label');
    contentUploadLabel.innerText = labelText;
    contentUploadLabel.setAttribute('for', 'content-upload-file-input');

    const contentUploadInput = document.createElement('input');
    contentUploadInput.setAttribute('type', 'file');
    contentUploadInput.setAttribute('id', 'content-upload-file-input');
    contentUploadInput.setAttribute('name', 'content-upload-file-input');

    const contentGroupDiv = document.createElement('div');
    contentGroupDiv.append(contentUploadLabel);
    contentGroupDiv.append(contentUploadInput);
    contentGroupDiv.setAttribute('id', 'content-upload-file');

    contentUploadInput.addEventListener('change', e => {
        previewFunction(e.target.files[0]);
    });

    return {label : contentUploadLabel, input : contentUploadInput, group : contentGroupDiv};
}

function soundCloudContentInsertInitialize() {
    const contentInsertSection = document.createElement('div');
    const contentInsertInput = createInsertUrl('Add a link to your SoundCloud audio', soundCloudContentUrlPreview);
    // const contentInsertMethod = document.createElement('select'); //in case there are multiple methods
    contentInsertSection.append(contentInsertInput);
    contentInsertSection.setAttribute('id', 'content-preview-section');

    document.getElementById('select-type-section').insertAdjacentElement('afterend', contentInsertSection);

}

async function soundCloudContentUrlPreview(e) {

    const contentInsertInput = e.target;
    const soundCloudUrl = contentInsertInput.value;

    
    const response = await fetch('https://soundcloud.com/oembed?url=' + soundCloudUrl, {
        method: 'GET',
        headers: {
            'Accept' : 'application/json'
        }
    });
    
    if (response.status==200) {
        const data = await response.json();
        
        const oldPreviewBlock = document.querySelector('#content-preview-soundcloud > iframe');
        const htmlCode = document.createElement('div');
        htmlCode.innerHTML = data.html;
                
        if (oldPreviewBlock!==null) {

            oldPreviewBlock.src = htmlCode.querySelector('iframe').src;
            
        } else {
            const previewBlock = document.createElement('div');
            const previewContent = document.createElement('iframe');
            
            previewContent.src = htmlCode.querySelector('iframe').src;
    
            previewBlock.append(previewContent);
            previewBlock.setAttribute('id', 'content-preview-soundcloud');
        
            document.getElementById('content-insert-url').insertAdjacentElement('beforebegin', previewBlock);
        }
    }

}

function youTubeContentInsertInitialize() {
    const contentInsertSection = document.createElement('div');
    const contentInsertInput = createInsertUrl('Add a link to your YouTube video', youTubeContentUrlPreview);
    // const contentInsertMethod = document.createElement('select'); //in case there are multiple methods
    contentInsertSection.append(contentInsertInput);
    contentInsertSection.setAttribute('id', 'content-preview-section');

    document.getElementById('select-type-section').insertAdjacentElement('afterend', contentInsertSection);

}

async function youTubeContentUrlPreview(e) {

    const contentInsertInput = e.target;
    const youtubeUrl = contentInsertInput.value;

    
    const response = await fetch('https://youtube.com/oembed?url=' + youtubeUrl, {
        method: 'GET',
        headers: {
            'Accept' : 'application/json'
        }
    });
    
    if (response.status==200) {
        const data = await response.json();
        
        const oldPreviewBlock = document.querySelector('#content-preview-youtube > iframe');
        const htmlCode = document.createElement('div');
        htmlCode.innerHTML = data.html;
                
        if (oldPreviewBlock!==null) {

            oldPreviewBlock.src = htmlCode.querySelector('iframe').src;
            
        } else {
            const previewBlock = document.createElement('div');
            const previewContent = document.createElement('iframe');
            
            previewContent.src = htmlCode.querySelector('iframe').src;
    
            previewBlock.append(previewContent);
            previewBlock.setAttribute('id', 'content-preview-youtube');
        
            document.getElementById('content-insert-url').insertAdjacentElement('beforebegin', previewBlock);
        }
    }

}

function imageContentUploadInitialize() {
    const contentUploadSection = document.createElement('div');
    const contentUploadLabelAndInput = createUploadFileLabelAndInput('Choose an image', imageContentUploadPreview);
    const contentUploadLabel = contentUploadLabelAndInput.label;
    const contentUploadInput = contentUploadLabelAndInput.input;
    const contentGroupDiv = contentUploadLabelAndInput.group;
    // const contentInsertMethod = document.createElement('select'); //in case there are multiple methods

    contentUploadInput.setAttribute('accept', '.jpg, .jpeg, .png, .gif');

    contentUploadSection.append(contentGroupDiv);
    contentUploadSection.setAttribute('id', 'content-preview-section');

    document.getElementById('select-type-section').insertAdjacentElement('afterend', contentUploadSection);

}

function imageContentUploadPreview(imageFile) {
    const oldPreviewImage = document.querySelector('#content-preview-image-upload > img');

    if(oldPreviewImage!==null) {
        oldPreviewImage.src = URL.createObjectURL(imageFile);
    } else {
        const previewBlock = document.createElement('div');
        const previewImage = document.createElement('img');
    
        previewImage.src = URL.createObjectURL(imageFile);
    
        previewBlock.append(previewImage);
        previewBlock.setAttribute('id', 'content-preview-image-upload');
    
        document.getElementById('content-upload-file').insertAdjacentElement('beforebegin', previewBlock);
    }


}

function pdfContentUploadInitialize() {
    const contentUploadSection = document.createElement('div');
    const contentUploadLabelAndInput = createUploadFileLabelAndInput('Choose a PDF file', pdfContentUploadPreview);
    const contentUploadLabel = contentUploadLabelAndInput.label;
    const contentUploadInput = contentUploadLabelAndInput.input;
    const contentGroupDiv = contentUploadLabelAndInput.group;
    // const contentInsertMethod = document.createElement('select'); //in case there are multiple methods

    contentUploadInput.setAttribute('accept', '.pdf');

    contentUploadSection.append(contentGroupDiv);
    contentUploadSection.setAttribute('id', 'content-preview-section');

    document.getElementById('select-type-section').insertAdjacentElement('afterend', contentUploadSection);

}

function pdfContentUploadPreview(pdfFile) {
    const oldPreviewPdf = document.querySelector('#content-preview-pdf-upload > embed');

    if(oldPreviewPdf!==null) {
        oldPreviewPdf.src = URL.createObjectURL(pdfFile);
    } else {
        const previewBlock = document.createElement('div');
        const previewPdf = document.createElement('embed');
    
        previewPdf.src = URL.createObjectURL(pdfFile);
    
        previewBlock.append(previewPdf);
        previewBlock.setAttribute('id', 'content-preview-pdf-upload');
    
        document.getElementById('content-upload-file').insertAdjacentElement('beforebegin', previewBlock);
    }


}



//--------------Resources functions-----------------------------------------------------------------------------
function linkInputChangeFinal(e) {
    const link = e.target.parentElement;
    const linkGroup = link.parentElement;
    const linkComment = link.querySelector('.create-resource-link > :last-child');

    const valuesPresent = linkAndCommentValuesPresent(link);
    const nextValuesPresent = nextLinkValuesPresent(link);

    console.log(valuesPresent, nextValuesPresent);
    

    if(!valuesPresent && link.nextSibling!==null) {
        link.remove();
    }

}

function linkInputChange(e) {
    const link = e.target.parentElement;
    const linkGroup = link.parentElement;
    const linkComment = link.querySelector('.create-resource-link > :last-child');

    const valuesPresent = linkAndCommentValuesPresent(link);
    const nextValuesPresent = nextLinkValuesPresent(link);

    console.log(valuesPresent, nextValuesPresent);
    

    if(valuesPresent) {
        linkComment.classList.remove('hidden-info');

        if(link.nextSibling===null)
            createNewLink(linkGroup);
    } else if (!valuesPresent) {
        linkComment.classList.add('hidden-info');

        if(!nextValuesPresent) {
            link.nextSibling.remove();
            console.log('next removed!');
            
        }

    }
}

function createNewLink(linkGroup) {
    const resourceLink = document.createElement('div');
    const resourceLinkInput = document.createElement('input');
    const resourceLinkComment = document.createElement('input');

    resourceLinkInput.placeholder = 'add a link';
    resourceLinkInput.addEventListener('input', e => linkInputChange(e));
    resourceLinkInput.addEventListener('change', e => linkInputChangeFinal(e));

    resourceLinkComment.placeholder = 'commentary...';
    resourceLinkComment.addEventListener('input', e => linkInputChange(e));
    resourceLinkComment.addEventListener('change', e => linkInputChangeFinal(e));
    resourceLinkComment.classList.add('hidden-info');

    resourceLink.append(resourceLinkInput);
    resourceLink.append(resourceLinkComment);
    resourceLink.classList.add('create-resource-link');

    linkGroup.append(resourceLink);

}

function linkAndCommentValuesPresent(link) {
    const linkInputs = link.querySelectorAll('input');

    for(let i of linkInputs) {
        if(i.value!=='')
            return true;
    }

    return false;
}

function nextLinkValuesPresent(link) {
    if(link.nextSibling!==null) {
        return linkAndCommentValuesPresent(link.nextSibling);
    }
}

//--------------Tags functions-----------------------------------------------------------------------------
function tagsInputKey(e) {
    const tagsInput = e.target;
    const tagsSection = tagsInput.parentElement;

    const key = e.key;

    if(key==='Enter' || key===',') {
        e.preventDefault();
        tagsInput.insertAdjacentElement('beforebegin', createTag(tagsInput.value));
        tagsInput.value = '';
    }

}

function createTag(tagName) {
    const newTag = document.createElement('div');
    newTag.classList.add('tag');

    const tagLabel = document.createElement('p');
    tagLabel.innerText = tagName;

    newTag.append(tagLabel);
    return newTag;
}

//--------------Buttons functions-----------------------------------------------------------------------------

async function publish(plaque, parentId, buttonSection, createWindow) {

    const request = createRequestObject();
    request.setMethod('POST');
    
    const node_window = plaque.querySelector('#create-node-window');

    const loadingScreen = createLoadingScreen(50, 50, 100);
    createWindow.append(loadingScreen);
    buttonSection.classList.add('hidden-info');
    
    const onResponseStatus4xxFunction = async (response) => {
        const message = await response.text();
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        

        if(message)
            insertPlaqueAndAlertWindow(message);
        else
            insertPlaqueAndAlertWindow('Something went wrong!');
    };
    const somethingWentWrong = () => {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow('Something went wrong!');
    };

    const previewCreationMethod = previewMethodRead(node_window);
    if(!previewCreationMethod) {
        const previewTypeCircle = createPreviewTypeCircle(plaque);
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow('Choose a type for your preview!');
        return null;
    }

    const nodeName = readName(node_window);
    
    const resources = readResources(node_window);
    
    const description = readDescription(node_window);
    
    const tags = readTags(node_window);

    if(nodeName===null || nodeName.length<1) {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow('Your branch needs to have a name!');
        return null;
    }

    let urlString = "/branches/submit";
    
    //Auth vs Anon definition
    const loginToken = localStorage.getItem("branchof_access_token");
    if(loginToken!==null && loginToken!==undefined) {
        urlString = urlString + "";
        request.addHeader('Token-Auth', `${localStorage.branchof_access_token}`);

        request.onResponseStatus('200', async (response)=>{
            insertPlaqueAndAlertWindow('You have branched successfully! Yay! :D');
            plaque.remove();
        });
    } else {
        urlString = urlString + "/anonymous";
        const anonToken = localStorage.getItem("branchof_anon_token");
        
        if(anonToken!==null && anonToken!==undefined)
            request.addHeader('Token-Anon', anonToken);
        
        //The default behavior (new anon-token is issued)
        request.onResponseStatus('201', async (response)=>{
            const reclaimToken = await response.text();
            insertPlaqueAndAlertWindowAndReclaimToken(reclaimToken);
            localStorage.setItem("branchof_anon_token", reclaimToken);
            plaque.remove();
        });

        //The irregular behavior (a pre-existing is used)
        request.onResponseStatus('200', async (response)=>{
            const reclaimToken = await response.text();
            insertPlaqueAndAlertWindowAndReclaimToken(reclaimToken, true);
            plaque.remove();
        });
        
    }

    request.setURL(urlString);

    const newNode = {};

    newNode.name = nodeName;

    if(resources!==null)
        newNode.resources = resources;

    if(description!==null)
        newNode.description = description;

    if(tags!==null)
        newNode.tags = tags;

    if(parentId!==null) {
        request.addSearchParam('parentId', parentId);
    }

    const previewCreationInjections = {};
    previewCreationInjections.onResponseStatus4xxFunction = onResponseStatus4xxFunction;
    previewCreationInjections.somethingWentWrong = somethingWentWrong;
    previewCreationInjections.loadingScreen = loadingScreen;
    previewCreationInjections.buttonSection = buttonSection;

    console.log("newNode ", newNode);
    console.log("request ", request);
    
    request.onResponseStatus('204', ()=> {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow('This parent branch doesn\'t exist');
    });
    request.onResponseStatus('417', () => {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow('We couldn\'t create your Branch. Try again later, please.');
    });
    request.onResponseStatus('401', () => {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        plaque.classList.add('hidden-info');

        localStorage.removeItem('branchof_access_token');
        localStorage.removeItem('branchof_access_username');
        insertPlaqueAndAlertSwitchingToAnon(plaque, parentId, buttonSection, createWindow);
    });
    request.onResponseStatus4xx(onResponseStatus4xxFunction);
    request.onResponseElse(somethingWentWrong);

    const contentPreviewSection = node_window.querySelector('#content-preview-section');
    const previewCreationPromise = createPreviewPromise(previewCreationMethod, contentPreviewSection, previewCreationInjections);

    previewCreationPromise.then(preview => {
        newNode.preview = preview;

        try {
            const sanitizedBranch = isValidBranch(newNode);
            request.setBodyJsonFromObject(sanitizedBranch);
            request.executeRequest();
        } catch (e) {
            if(e instanceof ValidationError) {
                loadingScreen.remove();
                buttonSection.classList.remove('hidden-info');
                insertPlaqueAndAlertWindow(e.message);
            } else {
                console.log("Error: ", e);
                throw e;
            }
        }
    

    }).catch((error) => {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow(error.message);
        console.log(error);
        return;
    });
}

function insertPlaqueAndAlertWindowAndReclaimToken(reclaimToken, tokenReused=false) {
    const plaqueAndAlert = insertPlaqueAndAlertWindow("You have branched anonymously");
    const alertWindow = plaqueAndAlert.alertWindow;

    alertWindow.classList.add('reclaim-token-alert-message');

    const line1 = createElement('p', null, null);
    line1.innerText = "Here is your Reclaim Token, so you can reclaim authorship later, once you are registered.";

    const reclaimTokenInput = createElement('input', null, null);
    reclaimTokenInput.value = reclaimToken;
    reclaimTokenInput.readOnly = true;

    reclaimTokenInput.addEventListener('click', () => {
        reclaimTokenInput.select(); // This selects the entire current value
      });

    const line2 = createElement('p', null, null);
    line2.innerText = "Save it, or you will lose access to your new branch.";

    alertWindow.appendToCenter(line1);
    alertWindow.appendToCenter(reclaimTokenInput);
    alertWindow.appendToCenter(line2);

    if(tokenReused===true) {
        line1.innerText = "Your branch has been credited to an already-existing token: ";
        line2.innerText = "This is the token that was used for other branches you created anonymously. Use this token to reclaim multiple branches later on.";
    }
    
    return plaqueAndAlert;
}

function insertPlaqueAndAlertSwitchingToAnon(plaque, parentId, buttonSection, createWindow) {
    const plaqueAndAlert = insertPlaqueAndAlertWindow("You have branched anonymously");
    const alertWindow = plaqueAndAlert.alertWindow;
    const alertWindowButton = alertWindow.alertWindowButton;
    alertWindowButton.remove();

    alertWindow.classList.add('switching-to-anon-alert-message');

    const line1 = createElement('p', null, null);
    line1.innerText = "Unfortunately, you've been logged out, or your login session has expired.";

    const line2 = createElement('p', null, null);
    line2.innerText = "You can re-login, or you can proceed with the Branch creation, but then your Branch will be lsited as an anonymous author's Branch.";

    const line3 = createElement('p', null, null);
    line3.innerText = "You will be able to reclaim your anonymous Branch with a special token we will issue for you after the Branch is created.";

    const buttonSectionNew = createElement('div', null, ['switching-to-anon-alert-button-section']);
    const reloginButton = createElement('button', null, null);
    makeNewButton(reloginButton, 'light-black', 'white', 'Log in again', 'lighten');
    reloginButton.addEventListener('click', () => {
        logOut();
    });
    const anonButton = createElement('button', null, null);
    makeNewButton(anonButton, 'grey', 'black', 'Publish Anonymously', 'darken');
    anonButton.addEventListener('click', () => {
        createWindow.classList.remove('hidden-info');
        plaqueAndAlert.remove();
        publish(plaque, parentId, buttonSection, createWindow);
    });

    buttonSectionNew.append(reloginButton, anonButton);

    alertWindow.appendToCenter(line1);
    alertWindow.appendToCenter(line2);
    alertWindow.appendToCenter(line3);
    alertWindow.appendToCenter(buttonSectionNew);
    
    return plaqueAndAlert;
}

function previewMethodRead(node_window) {
    const select = node_window.querySelector('#select-type-section > select');
    const previewMethod = listOfTypesReadProperties[select.value];
    return previewMethod;
}

function readName(node_window) {
    return node_window.querySelector('#name-section > textarea').value;
}

function readResources(node_window) {
    const resources = node_window.querySelectorAll('.create-resource-link');
    const resourceArray = [];

    for (let resource of resources) {
        const resourceObject = {
            link : resource.querySelector(':first-child').value,
            commentary : resource.querySelector(':last-child').value
        }

        if(resourceObject.link!=='')
            resourceArray.push(resourceObject);
    }

    if(resourceArray.length===0)
        return null;

    return resourceArray;
}

function checkResource(resource) {
    if (resource.querySelector(':first-child').value!=='')
        return true;
}

function readDescription(node_window) {
    const description = node_window.querySelector('#description-section > textarea');

    if(description.value===null || description.value.length===0)
        return null;

    return description.value;
}

function readTags(node_window) {
    const tags = node_window.querySelectorAll('.tag > p');
    const tagsArray = [];

    for (let tag of tags) {
        tagsArray.push(tag.innerText);
    }

    if(tagsArray.length===0)
        return null;

    return tagsArray;
}